<template>
  <div><img :src="`${'/img/footer_logo.svg'}`" alt="Bitbeli logo" w-268px sm:w-205px h-auto mx-auto sm:ml-0></div>
</template>
